import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttachmentsTypesRoutingModule } from './attachments-types-routing.module';
import { AttachmentsTypesListComponent } from './attachments-types-list/attachments-types-list.component';
import { AttachmentsTypesDetailComponent } from './attachments-types-detail/attachments-types-detail.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CoreModule } from 'src/app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [AttachmentsTypesListComponent, AttachmentsTypesDetailComponent],
  imports: [
    CommonModule,
    AttachmentsTypesRoutingModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    ConfirmDialogModule,
    DialogModule,
    FormsModule,
    CheckboxModule,
    CoreModule,
    CardModule,
    FontAwesomeModule,
    AppRoutingModule,
    TranslateModule
  ],
  exports:[AttachmentsTypesListComponent, AttachmentsTypesDetailComponent]
})
export class AttachmentsTypesModule { }
